import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const SelfExclusionWrapper = styled('div', { label: 'SelfExclusionWrapper' })`
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-family: var(--font-family-primary);
`;

export const SelfExclusionSection = styled('section', { label: 'SelfExclusionSection' })`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    border: 1px solid ${mainColors.grays.gray200};
    border-radius: 8px;
    background-color: ${mainColors.default.light};
`;

export const SelfExclusionFormRow = styled('div', { label: 'SelfExclusionFormRow' })`
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
    }
`;

export const SelfExclusionFormLabel = styled('span', { label: 'SelfExclusionFormLabel' })`
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    color: ${mainColors.main.primary};
    flex: 1;
`;

export const SelfExclusionReadOnlyValue = styled('span', { label: 'SelfExclusionReadOnlyValue' })`
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    color: ${mainColors.grays.gray500};
`;

export const SelfExclusionPropertyList = styled('div', { label: 'SelfExclusionPropertyList' })`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-start;
`;

export const SelfExclusionProperty = styled('span', { label: 'SelfExclusionProperty' })`
    padding: 4px 8px;
    border-radius: 6px;
    background-color: ${mainColors.grays.gray100};
    border: 1px solid ${mainColors.grays.gray200};
    font-size: 13px;
    line-height: 1.43;
    color: ${mainColors.main.primary};
`;

export const SelfExclusionActions = styled('div', { label: 'SelfExclusionActions' })`
    display: flex;
    justify-content: flex-start;
    margin-top: 8px;
`;
